import { validateTidalLicense } from "../base/index.js";
export * from "react-error-boundary";
validateTidalLicense();
//# sourceMappingURL=index.js.map
